<template>
  <div>

    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Filtres</h5>
        <div class="row">
          <div class="col-sm-3">
            <select class="browser-default custom-select"
               v-model="f_rliss">
              <option value="0">Tous les RLISS...</option>
              <option v-for="rl in rliss" :key="rl.rliss_id"
                :value="rl.rliss_id" v-text="rl.rliss_fr"></option>
            </select>
          </div>
          <div class="col-sm-3">
            <input class="form-control" type="text" placeholder="Fournisseur"
              v-model="f_fournisseur" />
          </div>
          <div class="col-sm-3">
            <div class="form-check">
              <label class="form-check-input">
              <input class="form-check-input" type="checkbox" v-model="f_non_debut">
                Exclure les plans non-débutés
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <table class="table table-sm table-bordered" style="table-layout: fixed"> -->
    <table>
      <thead>
        <tr>
          <th class="truncate" colspan="4"></th>
          <th class="group" colspan="4">2019-2020</th>
          <th class="group" colspan="4">2020-2021</th>
          <th class="group" colspan="3">2019-2020  &rarr; 2020-2021</th>
        </tr>
        <tr>
          <th class="truncate" style="width: 200px">RLISS</th>
          <th class="truncate" style="max-width: 400px;">Fournisseur</th>
          <th style="text-align: center; width: 60px;">Statut</th>
          <th style="text-align: center; width: 150px;">Rapport<br />2020-2021</th>
          <th class="rotate"><div><span>Iden. les francos</span></div></th>
          <th class="rotate"><div><span>Jumelage</span></div></th>
          <th class="rotate"><div><span>Réfère</span></div></th>
          <th class="rotate"><div><span>Capture la satis.</span></div></th>
          <th class="rotate"><div><span>Iden. les francos</span></div></th>
          <th class="rotate"><div><span>Jumelage</span></div></th>
          <th class="rotate"><div><span>Réfère</span></div></th>
          <th class="rotate"><div><span>Capture la satis.</span></div></th>
          <th style="text-align: center; width: 100px;">Clients franco</th>
          <th style="text-align: center; width: 100px;">RH</th>
          <th style="text-align: center; width: 100px;">Exigences</th>
        </tr>
      </thead>
      <tbody>
        <OnValidationRow v-for='f in filteredFss' :fss="f" :key='f.agency_id'>

        </OnValidationRow>
      </tbody>
    </table>
  </div>
</template>

<style>
th.group {
  border-left: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
  text-align: center;
}

th.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

th.rotate {
  /* Something you can count on */
  height: 140px;
  white-space: nowrap;
}

th.rotate > div {
  transform:
    /* Magic Numbers */
    translate(0px, 0px)
    /* 45 is really 360 - 45 */
    rotate(315deg);
  width: 30px;
}
th.rotate > div > span {
  border-bottom: 1px solid #ccc;
  padding: 5px 10px;
}
</style>

<script>
// Ce fichier est encore en développement, et non utilisé

import OnValidationRow from '@/components/OnValidationRow.vue'

export default {
  name: 'ValidationList',
  data() { return{
    f_rliss: 0,
    f_non_debut: false,
    f_fournisseur: ""
  }},
  props: {
    fss: Array,
    rliss: Array
  },
  components: {
    OnValidationRow,
  },
  computed: {
    filteredFss() {
      return this.fss.filter(fss =>
        ((this.f_rliss==0 || fss.r_id==this.f_rliss) &&
         (!this.f_non_debut || fss.statut_plan_id1819!=1) &&
         (this.f_fournisseur=="" ||
            fss.agency_name.toUpperCase().indexOf(
              this.f_fournisseur.toUpperCase()) > -1)
       )
      )
    }
  },
  methods: {
    percent(a, b) {
      if(b==0) return "n/a";
      return (100*a/b).toFixed(1) + "%";
    },
    remplis(a, b) {
      return a.toString() + "/" + b.toString();
    },
    url(id) {
      return '/on/comparaison/'+id;
    }
  }
}
</script>
<style>
div.card {
  margin-bottom: 15px;
}
</style>
